import selectFolderWithFallback from '../orchestrators/selectFolderWithFallback';
export default function mailFolderRouteHandler(parameters) {
    selectFolderWithFallback(parameters.folderId);
}
//# sourceMappingURL=mailFolderRouteHandler.js.map